angular
  .module("AccountingBoxApp")
  .config(function($stateProvider, $ocLazyLoadProvider) {
    $stateProvider
      .state("app.company.purchases", {
        abstract: false,
        template: "<ui-view/>",
        url: "/purchases"
      })
      .state("app.company.edit.purchases", {
        url: "/purchases/:id",
        templateUrl: "app/purchases/edit/edit.html",
        controller: "PurchasesEditCtrl",
        controllerAs: "e",
        params: {
          purchase: null
        }
      })
      .state("app.company.new.purchases", {
        url: "/purchases/new/:id",
        templateUrl: "app/purchases/edit/edit.html",
        controller: "PurchasesEditCtrl",
        controllerAs: "e",
        params: {
          attachment: null
        }
      })
      .state("app.company.purchases.list", {
        url: "",
        template: '',
        // templateUrl: "app/purchases/list/list.html",
        // controller: "ListCtrl",
        // controllerAs: "l"
        /*resolve: {
                deps: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'dataTables'
                            /*
                                Load any ocLazyLoad module here
                                ex: 'wysihtml5'
                                Open config.lazyload.js for available modules
                            */
        /* ], {
                     insertBefore: '#lazyload_placeholder'
                 })
                /* .then(function() {
                     return $ocLazyLoad.load([
                         'app/purchases/list/list.controller.js'
                     ]);

                 })*/
        /*;
                                }]
                                }*/
      })
      .state("app.company.purchases.view", {
        url: "/:id/view",
        templateUrl: "app/purchases/view/view.html",
        controller: "ViewCtrl",
        controllerAs: "v"
      });
    /* .state('app.company.purchases.edit', {
                url: '/:id/bewerk',
                templateUrl: 'app/transaction/transaction.html',
                controller: 'TransactionCtrl',
                controllerAs: 'tra',
                //   css: 'app/purchases/edit/edit.css',
                /* resolve: {
                deps: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'datepicker'
                        ], {
                            insertBefore: '#lazyload_placeholder'
                        }) .then(function() {
                            return $ocLazyLoad.load([
                                '../../assets/plugins/bootstrap-datepicker/js/locales/bootstrap-datepicker.nl.js'
                           ]);
});

                }]
            }*/
    //  });
    /*  .state('app.company.purchases.new', {
                url: '/nieuw',
                templateUrl: 'app/transaction/transaction.html',
                controller: 'TransactionCtrl',
                controllerAs: 'tra',
                /*  resolve: {
                deps: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'datepicker'
                        ], {
                            insertBefore: '#lazyload_placeholder'
                        }) .then(function() {
                            return $ocLazyLoad.load([
                                '../../assets/plugins/bootstrap-datepicker/js/locales/bootstrap-datepicker.nl.js'
                           ]);
});

                }]
            }*/
    /*});*/
  });
